function validateTime(value) {
  if (!value) return "Start time is required";

  // Must be exactly HH:MM
  if (!/^\d{2}:\d{2}$/.test(value)) {
    return "Time must be in HH:MM format";
  }

  const [hours, minutes] = value.split(":").map(Number);

  if (hours < 0 || hours > 23) {
    return "Hours must be between 00 and 23";
  }

  if (minutes < 0 || minutes > 59) {
    return "Minutes must be between 00 and 59";
  }

  return null;
}

export default validateTime;
